export default __webpack_public_path__ + "12213d7f20f8337f2c405efd2c90a1f2.webp";